exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".colorTecni {\r\n    color: #333;\r\n}\r\n\r\n.tabTecni .nav-tabs li.active a {\r\n    color: #A14950;\r\n    background-color: #EDEDED;\r\n}\r\n\r\n.p {\r\n    color: red;\r\n    border: none;\r\n    font-size: 12px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/masivos/datosGenerales/datos-generales.style.css
// module id = ../../../../../src/app/views/masivos/datosGenerales/datos-generales.style.css
// module chunks = 0